import { createSelector } from 'reselect';

export const dictionariesStateSelector = state => state.stickers.dictionaries;


export const themesGroupsSelector = createSelector(
  dictionariesStateSelector,
  state => {
    const ids = Object.keys(state.themesGroupsByIds);
    return ids.map((id) => state.themesGroupsByIds[id]);
  }
);

export const themesSelector = createSelector(
  dictionariesStateSelector,
  state => {
    const ids = Object.keys(state.themesTemplatesByIds);
    return ids.map((id) => state.themesTemplatesByIds[id]);
  }
);

export const defaultThemeTemplateSelector = createSelector(
    dictionariesStateSelector,
    state => state.defaultThemeTemplate
);

export const defaultThemeGroupSelector = createSelector(
    dictionariesStateSelector,
    state => state.defaultThemeGroup
);

export const textTemplatesGroupsSelector = createSelector(
  dictionariesStateSelector,
  state => {
    const ids = Object.keys(state.textsGroupsByIds);
    return ids.map((id) => state.textsGroupsByIds[id]);
  }
);

export const textTemplatesSelector = createSelector(
  dictionariesStateSelector,
  state => {
    const ids = Object.keys(state.textsTemplatesByIds);
    return ids.map((id) => state.textsTemplatesByIds[id]);
  }
);

export const defaultTextTemplatesGroupSelector = createSelector(
    dictionariesStateSelector,
    state => state.defaultTextTemplatesGroup
);
